// extracted by mini-css-extract-plugin
module.exports = {"container":"DocsLayout_container__3C-nQ","header":"DocsLayout_header__3ozbQ","content":"DocsLayout_content__3A5MN"};